<template>
    <hp5-semantic size-selection="xs">
      <span>
        ({{ distance }} miles)
        <hp5-spacing-vertical xs="xs"></hp5-spacing-vertical>
      </span>
    </hp5-semantic>
</template>

<script setup>

    const props = defineProps({
        result: Object
    })

    const distance = computed(() => props.result.distanceInMiles )

</script>

<style lang="scss" scoped>
  span {
    margin-left: 21px;
    color: var(--color-neutral-dark);
    font-family: var(--text-heading-font-xs);
    font-size: var(--text-heading-pixels-xs);
    line-height: var(--text-body-line-height-xs);
  }
</style>